export default __webpack_public_path__ + "static/media/arrow_left_right.608a825a.svg";